import {Component, Input, OnInit} from '@angular/core';
import {AffiliateService} from '../../affiliate.service';
import {Constants} from '../../../../shared/utils/constants';

@Component({
  selector: 'fx-link-control-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.sass']
})
export class UserComponent implements OnInit {
  @Input() permission;
  @Input() originFE;
  keyword = '';
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  listTrades = [];
  constructor(
    private service: AffiliateService
  ) { }

  ngOnInit(): void {
    this.getListTraderCampaign();
  }
  private getListTraderCampaign(): void {
    const option = {
      q: (this.keyword) ? encodeURIComponent((this.keyword).trim()) : this.keyword,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize
    };
    this.service.getListTraderCampaign(option)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listTrades = res.data;
          this.listTrades =this.listTrades.map((item)=> {
            item.url = item.code?.includes('user-') ? this.originFE?.slice(0,-13)  : this.originFE ;
            return item;
          })
          this.pageInfo.totalRecord = res.paging.total;
        }
      });
  }

  search(event = null): void {
    if (event) {
      if (event.keyCode === 13) {
        this.getListTraderCampaign();
      }
    } else {
      this.getListTraderCampaign();
    }
  }
  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getListTraderCampaign();
  }
}
